import React, {useEffect, useState} from 'react';
import {Route, Switch} from 'react-router-dom';
import cx from 'classnames';
import {connect} from "react-redux";
import SweetAlert from "sweetalert-react";
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import {
    Button,
    Card,
    Col,
    Container,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Form,
    Input,
    InputGroup,
    InputGroupAddon,
    ListGroupItem,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledButtonDropdown,
} from "reactstrap";

import APITable2 from "../../../Components/APITable2";
import AppWrapper from '../../../Layout/AppWrapper';
import PageTitle from "../../../Layout/AppMain/PageTitle";
import APIForm from "../../../Components/APIForm";
import FlowBuilder from "./FlowBuilder";
import {duplicateFlow} from "../../../thunks/Steps";
import {getTemplates, installTemplate} from "../../../thunks/Templates";
import noImage from '../../../assets/utils/images/avatars/ava.jpg';
import {SHOP_SOURCE_ONE_MESSAGE} from "../../../constants";
import SideTabs from "../../../Components/SideTabs";
import Common from "./Components/Common";
// import Scenario from "./Components/Scenario";
import CustomFields from "./Components/CustomFields";
import Notifications from "./Components/Notifications";
import Tags from "./Components/Tags";
// import YouTube from "react-youtube";
import {eventsLogEvent} from "../../../Components/utils";
import CopyStoreSettings from "./Components/CopyStoreSettings";


const API_PATH = 'step/flows';

const TableHeader = () => {
    const {t, i18n} = useTranslation();

    return <ListGroupItem className='pl-md-5 pl-4'>
        <div className="widget-content py-1 px-0 px-md-2">
            <div className="widget-content-wrapper widget-content-header">
                <div className="widget-content-left" style={{width: '100%'}}>
                    {t('flows.table_header.column.name', 'Name')}
                </div>
                <div className="widget-content-right" style={{width: 170}}>
                    {t('flows.table_header.column.changed_at', 'Changed at')}
                </div>
                <div className="widget-content-right" style={{width: 100}}>

                </div>
            </div>
        </div>
    </ListGroupItem>;
};

const TableRow = (
    {
        data,
        setIdSelected,
        actionClick,
        actionDelete,
        reloadData,
        apiFormSubmitRequest,
        duplicateFlow,
    }
) => {
    const {t, i18n} = useTranslation();

    /**
     * Переименовать
     */
    const [renameInputVal, setRenameInputVal] = useState(data.name);
    const [renameFormShow, setRenameFormShow] = useState(false);

    const actionRename = () => {
        setRenameFormShow(true);
    };

    const onRenameInputChange = (event) => {
        setRenameInputVal(event.target.value);
    };

    const onRenameFormSubmit = (event) => {
        event.preventDefault();

        const apiUrl = `${API_PATH}/${data.id}/`;
        const method = 'patch';
        const formData = {
            shop_id: data.shop_id,
            name: renameInputVal,
        };
        const callback = (response) => {
            setRenameFormShow(false);
        };
        apiFormSubmitRequest(
            apiUrl,
            method,
            formData,
            undefined,
            callback,
        );
    };

    const onRenameCancel = (event) => {
        event.preventDefault();

        setRenameInputVal(data.name);
        setRenameFormShow(false);
    };

    /**
     * Установить по умолчанию
     */
    const [makeDefaultPopupShown, setMakeDefaultPopupShown] = useState(false);

    const actionMakeDefault = () => {
        if (data.is_default) {
            return;
        }

        setMakeDefaultPopupShown(true);
    };

    const makeNotDefault = () => {
        const apiUrl = `${API_PATH}/${data.id}/`;
        const method = 'patch';
        const formData = {
            shop_id: data.shop_id,
            is_default: false,
        };
        const callback = (response) => {

            setMakeDefaultPopupShown(false);
            reloadData();
        };
        apiFormSubmitRequest(
            apiUrl,
            method,
            formData,
            undefined,
            callback,
        );
    };

    const confirmMakeDefault = () => {
        const apiUrl = `${API_PATH}/${data.id}/`;
        const method = 'patch';
        const formData = {
            shop_id: data.shop_id,
            is_default: true,
        };
        const callback = (response) => {

            setMakeDefaultPopupShown(false);
            reloadData();
        };
        apiFormSubmitRequest(
            apiUrl,
            method,
            formData,
            undefined,
            callback,
        );
    };

    const cancelMakeDefault = () => {
        setMakeDefaultPopupShown(false);
    };

    /**
     * Создать копию
     */
    const actionCreateCopy = () => {
        const callback = (response) => {
            reloadData();
        };
        duplicateFlow(data.id, callback);
    };

    /**
     * Рендеринг
     */
    return <ListGroupItem
        className={cx('hover-bg-light pl-md-5 pl-4 hover-pointer', {isDefault: data.is_default})}
        onClick={() => actionClick(data.id)}
    >
        <div className="widget-content py-1 px-0 px-md-2">
            <div className='widget-content-wrapper'>
                <div className='widget-content-left' style={{width: '100%'}}>
                    {
                        renameFormShow ?
                            <Form inline onSubmit={onRenameFormSubmit} onClick={(event) => event.stopPropagation()}>
                                <InputGroup row className='m-0'>
                                    <Input
                                        name="name"
                                        placeholder={t('flows.table_row.rename.placeholder', 'Flow name')}
                                        value={renameInputVal}
                                        onChange={onRenameInputChange}
                                    />
                                    <InputGroupAddon addonType="append">
                                        <Button color="light" className='align-items-center pt-1 pb-0 px-2'
                                                onClick={onRenameCancel}>
                                            <i className="pe-7s-close fsize-3"/>
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Form>
                            : renameInputVal
                    }
                </div>
                <div className="widget-content-right" style={{width: 170}}>
                    {data.updated_at}
                </div>
                <div className="widget-content-right text-right" style={{width: 100}}>
                    <UncontrolledButtonDropdown onClick={(event) => event.stopPropagation()}>
                        <DropdownToggle
                            outline
                            className="pb-1 pt-2 br-a"
                            color="success"
                            onClick={() => setIdSelected(data.id)}
                        >
                            <i className="pe-7s-more font-size-lg"/>
                        </DropdownToggle>
                        <DropdownMenu right>
                            <DropdownItem onClick={actionRename}>
                                <i className="pe-7s-pen mr-2 fsize-15"/> {t('flows.table_row.menu.rename', 'Rename')}
                            </DropdownItem>

                            <DropdownItem className={cx({disabled: data.is_default})} onClick={actionMakeDefault}>
                                <i className="pe-7s-play mr-2 fsize-15"
                                   style={{marginTop: 2}}/> {t('flows.table_row.menu.make_default', 'Make default')}
                            </DropdownItem>

                            <DropdownItem className={cx({disabled: !data.is_default})} onClick={makeNotDefault}>
                                <i className="pe-7s-close-circle mr-2 fsize-15"
                                   style={{marginTop: 2}}/> {t('flows.table_row.menu.turn_off', 'Turn off')}
                            </DropdownItem>

                            <DropdownItem onClick={actionCreateCopy}>
                                <i className="pe-7s-copy-file mr-2 fsize-15"/> {t('flows.table_row.menu.duplicate', 'Duplicate')}
                            </DropdownItem>

                            <DropdownItem className='text-danger' onClick={actionDelete}>
                                <i className="pe-7s-trash mr-2 fsize-15"/> {t('flows.table_row.menu.remove', 'Remove')}
                            </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledButtonDropdown>
                </div>
            </div>
        </div>

        <SweetAlert
            title={t('flows.alert.make_flow_default.title', 'Are you sure you want to make this flow default?')}
            confirmButtonColor="#d92550"
            show={makeDefaultPopupShown}
            text={t('flows.alert.make_flow_default.text', 'Only one flow can be a default one at a time. A previous default flow will be longer marked as default one.')}
            type="warning"
            showCancelButton
            cancelButtonText={t('flows.alert.make_flow_default.button.cancel', 'Cancel')}
            onConfirm={confirmMakeDefault}
            onCancel={cancelMakeDefault}
        />
    </ListGroupItem>;
};


const mapDispatchToTableRowProps = dispatch => ({
    duplicateFlow: (flowId, callback) => dispatch(duplicateFlow(flowId, callback)),
});

const EnhancedTableRow = connect(null, mapDispatchToTableRowProps)(TableRow);


const Flows = (
    {
        match,
        activeShop,
        shops,
        isSendingInstallRequest,
        templates,

        getTemplates,
        installTemplate,
        enableMobileMenu
    }
) => {
    const {t, i18n} = useTranslation();
    const isRu = i18n.language.toString().indexOf('ru') !== -1;


    // State
    const [selectedTemplate, setSelectedTemplate] = useState(undefined);

    // --------------------------
    // Hooks
    // --------------------------
    // componentDidMount && componentDidUpdate
    useEffect(
        () => {
            getTemplates({});
        },
        []
    );


    const urlToGo = match.url.lastIndexOf('/')===match.url.length-1?match.url:`${match.url}/`;

    return <Switch>
        <Route
            exact path={`${match.url}/create/`}
            render={
                (props) =>
                    <AppWrapper>
                            <div className="app-main__inner">
                                <PageTitle
                                    heading={t('flows.page.create_flow.title', 'Create flow')}
                                    // icon="pe-7s-share icon-gradient bg-mean-fruit"
                                    headerButtonSettingsUrl={`${match.url}/settings/common/`}
                                    enablePageTitleSettingsButton={true}
                                    headerButtonBackUrl={`${match.url}/`}
                                    enablePageTitleBackButton={true}
                                />
                                <APIForm
                                    apiPath={API_PATH}
                                    modelId={undefined}
                                    method='post'
                                    deletionDisabled={true}
                                    actionRedirectUrl={`${match.url}/`}
                                />
                            </div>
                    </AppWrapper>
            }
        />
        <Route
            path={`${match.url}/settings/`}
            render={
                () => <AppWrapper>
                            <div className="app-main__inner">
                                <PageTitle
                                    heading={t('flows.page.settings_flow.title', 'Settings')}
                                    // icon="pe-7s-share icon-gradient bg-mean-fruit"
                                    // headerButtonCreateUrl={`${match.url}/create/`}
                                    // enablePageTitleCreationButton={false}
                                    headerButtonBackUrl={`${match.url}/`}
                                    enablePageTitleBackButton={true}
                                />
                                <SideTabs data={[
                                    {
                                        link: `${match.url}/settings/common/`,
                                        icon: "pe-7s-home check-nav-icon mt-4 mb-2",
                                        title: t('settings.common.page.title', 'General settings'),
                                        component: <Common/>
                                    },
                                    // {
                                    //     link: `${match.url}/settings/scenario/`,
                                    //     icon: "pe-7s-share check-nav-icon mt-4 mb-2",
                                    //     title: t('flows.page.settings_flow.script_settings', 'Script settings'),
                                    //     component: <Scenario/>
                                    // },
                                    {
                                        link: `${match.url}/settings/custom_fields/`,
                                        icon: "pe-7s-diskette check-nav-icon mt-4 mb-2",
                                        title: t('settings.custom_fields.page.title', 'Custom fields'),
                                        component: <CustomFields url={`${match.url}/settings/custom_fields`}/>
                                    },
                                    {
                                        link: `${match.url}/settings/tags/`,
                                        icon: "pe-7s-ticket check-nav-icon mt-4 mb-2",
                                        title: t('settings.tags.page.title', 'Tags'),
                                        component: <Tags url={`${match.url}/settings/tags`}/>
                                    },
                                    {
                                        link: `${match.url}/settings/notifications/`,
                                        icon: "pe-7s-volume2 check-nav-icon mt-4 mb-2",
                                        title: t('flows.page.settings_flow.administrator_notification', 'Administrator notification'),
                                        component: <Notifications url={`${match.url}/settings/notifications`}/>
                                    },
                                ]}/>
                            </div>
                </AppWrapper>
            }
        />
        <Route
            exact path={`${match.url}/:flowId(\\d+)/`}
            component={FlowBuilder}
        />
        <Route
            exact path={match.url}
            render={
                (props) => <>
                    <AppWrapper>
                            <div className="app-main__inner">
                                <PageTitle
                                    heading={t('flows.page.flows_list.title', 'Flows')}
                                    // icon="pe-7s-share icon-gradient bg-mean-fruit"
                                    headerButtonCreateUrl={`${urlToGo}create/`}
                                    headerButtonCreateCallback={() => eventsLogEvent('constructor_push_button_createflow')}
                                    enablePageTitleCreationButton={true}
                                    headerButtonSettingsUrl={`${urlToGo}settings/common/`}
                                    enablePageTitleSettingsButton={true}
                                    subButton={shops?.length > 1? <CopyStoreSettings apiPath={API_PATH}/> : null}
                                />


                                <APITable2
                                    HeaderComponent={TableHeader}
                                    RowComponent={EnhancedTableRow}
                                    emptyMessage={t('flows.list.message.no_data', 'No flows')}
                                    deleteMessage={t('flows.list.message.confirm_flow_removal', 'Are you sure you want to remove the flow?')}
                                    apiPath={API_PATH}
                                />
                            </div>
                    </AppWrapper>
                    <Modal isOpen={selectedTemplate}
                           toggle={() => setSelectedTemplate(undefined)}
                           size='sm'
                        // centered={true}
                    >
                        <ModalHeader toggle={() => setSelectedTemplate(undefined)}
                                     cssModule={{'modal-title': 'w-100 text-center mb-0'}}>
                            {get(selectedTemplate, 'name')}
                        </ModalHeader>
                        <ModalBody>
                            <p>{get(selectedTemplate, 'description')}</p>
                        </ModalBody>
                        <ModalFooter className='justify-content-center flex-column'>
                            <Button
                                size="lg"
                                color="primary"
                                className="px-5"
                                disabled={isSendingInstallRequest}
                                onClick={() => installTemplate(
                                    selectedTemplate.id,
                                    (result) => {
                                        toast.success(t('flows.templates.toast_success', 'Template installed successfully!'));
                                        setTimeout(() => window.location.reload(), 500)
                                    }
                                )}
                            >
                                {t('flows.templates.popup.install_button', 'Install')}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </>
            }
        />
    </Switch>;
};


const mapStateToFlowsProps = state => ({
    activeShop: state.Shops.activeShop,
    shops: state.Shops.shops,
    isSendingInstallRequest: state.Templates.isSendingInstallRequest,
    templates: state.Templates.templates,
    enableMobileMenu: state.ThemeOptions.enableMobileMenu,
});

const mapDispatchToFlowsProps = dispatch => ({
    getTemplates: (filters, callback) => dispatch(getTemplates(filters, callback)),
    installTemplate: (templateId, callback) => dispatch(installTemplate(templateId, callback)),
});

export default connect(mapStateToFlowsProps, mapDispatchToFlowsProps)(Flows);
